import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./TacticEditor.css";

function defaultStatement(kind) {
  switch (kind) {
    case "action":
      return { kind: "action", action: 1000 };
    case "conditional_action":
      return { kind: "if", condition: { kind: "atom", value: 100 }, then: [{ kind: "action", action: 1000 }] };
    case "if":
      return { kind: "if", condition: { kind: "atom", value: 100 }, then: [] };
    case "block":
      return { kind: "block", statements: [] };
    default:
      return null;
  }
}

/**
 * @param {{ onAdd: (statement: object) => void, depth: number, insert: boolean }} props
 */
export function AddStatementMenu({ onAdd, depth = 0, insert = false }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const STATEMENT_TYPES = [
    { kind: "action",             label: t("tactic.kindAction"),    description: t("tactic.kindActionDesc") },
    { kind: "conditional_action", label: t("tactic.kindCondition"), description: t("tactic.kindConditionDesc") },
  ];

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const handleSelect = (kind) => {
    const stmt = defaultStatement(kind);
    if (stmt) onAdd(stmt);
    setOpen(false);
  };

  return (
    <div
      className={`add-statement-menu ${insert ? "insert-menu" : ""}`}
      ref={ref}
      style={{ paddingLeft: `${depth * 1.5}rem` }}
    >
      <button
        className={insert ? "insert-btn" : "add-statement-btn"}
        onClick={() => setOpen((o) => !o)}
        title={insert ? t("tactic.insertRule") : undefined}
      >
        {insert ? "⊕" : t("tactic.addRule")}
      </button>
      {open && (
        <div className="add-statement-dropdown">
          {STATEMENT_TYPES.map(({ kind, label, description }) => (
            <button
              key={kind}
              className="add-statement-option"
              onClick={() => handleSelect(kind)}
            >
              <span className="add-option-label">{label}</span>
              <span className="add-option-desc">{description}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
